<template>
    <div>
        <div
            v-if="!noFiltersToDisplay"
            :class="{ busy: loading }"
            class="px-1 py-1 hidden-xs-down d-flex"
        >
            <div class="desktop-filters-container">
                <div v-if="$scope.IS_REGULAR_CUSTOMER" class="mr-3 hidden-md-down">
                    <i class="icon-cr icon-equalizer" />
                </div>
                <CatalogFilterGroupDesktop
                    v-if="!$scope.IS_REGULAR_CUSTOMER"
                    :value="selected.inPhysicalStock"
                    class="mr my-1 text-uppercase"
                    :label="$t('productionType')"
                    :fallback-value-label="'Tipo produção'"
                >
                    <CatalogFilterGroupOption
                        v-for="stock in filters.stock_filter"
                        :key="stock.id"
                        :label="stock.name"
                        :value="stock.id"
                        url-param="inPhysicalStock"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterTypes"
                    :value="selectedTypeId ? selected.type_url : undefined"
                    class="mr my-1 text-uppercase"
                    :label="$t('type')"
                >
                    <CatalogFilterGroupOption
                        v-show="selected.type_id && selected.type_id < 500"
                        :link="selected.type_url"
                        :value="undefined"
                        label="Todos os Tipos"
                        url-param="tipo"
                        id-prefix="desktop"
                    />
                    <CatalogFilterGroupOption
                        v-for="type in filters.types"
                        v-show="type.count > 0"
                        :key="type.id"
                        :count="type.count"
                        :label="type.name"
                        :link="type.url"
                        :value="type.url"
                        url-param="tipo"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterGenders"
                    :value="selected.gender_url"
                    class="mr my-1 text-uppercase"
                    :label="$t('gender')"
                >
                    <CatalogFilterGroupOption
                        :link="selected.gender_url"
                        :value="undefined"
                        label="Todos os Gêneros"
                        url-param="genero"
                        id-prefix="desktop"
                    />
                    <CatalogFilterGroupOption
                        v-for="gender in filters.genders"
                        v-show="gender.count > 0"
                        :key="gender.id"
                        :label="gender.name"
                        :link="gender.url"
                        :value="gender.url"
                        url-param="genero"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterModels"
                    :value="selected.model_url"
                    class="mr my-1 text-uppercase"
                    label="Modelo"
                >
                    <CatalogFilterGroupOption
                        :link="selected.model_url"
                        :value="undefined"
                        label="Todos os Modelos"
                        url-param="modelagem"
                        id-prefix="desktop"
                    />
                    <CatalogFilterGroupOption
                        v-for="model in filters.models"
                        v-show="model.count > 0"
                        :key="model.id"
                        :label="model.name"
                        :link="model.url"
                        :value="model.id"
                        url-param="modelagem"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterSizesAdult || displayFilterSizesChild || displayFilterSizes"
                    :value="selected.size"
                    class="mr my-1 text-uppercase"
                    :label="$t('size')"
                >
                    <CatalogFilterGroupOption
                        :value="undefined"
                        label="Todos os Tamanhos"
                        url-param="tamanho"
                        id-prefix="desktop"
                    />
                    <div v-if="displayFilterSizesAdult">
                        <hr class="my-2" />
                        <div class="text-secondary ml-4 text-uppercase">
                            {{ $t('adult') }}
                        </div>
                        <CatalogFilterGroupOption
                            v-for="size in filters.sizes_adult"
                            v-show="size.count > 0"
                            :key="size.name"
                            :label="size.name"
                            :link="size.url"
                            :value="size.name"
                            url-param="tamanho"
                            id-prefix="desktop"
                        />
                    </div>
                    <div v-if="displayFilterSizesChild">
                        <hr class="my-2" />
                        <div class="text-secondary ml-4 text-uppercase">
                            {{ $t('_product.kids') }}
                        </div>
                        <CatalogFilterGroupOption
                            v-for="size in filters.sizes_child"
                            v-show="size.count > 0"
                            :key="size.name"
                            :label="size.name"
                            :link="size.url"
                            :value="size.name"
                            url-param="tamanho"
                            id-prefix="desktop"
                        />
                    </div>
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterColors"
                    :value="selected.color_url"
                    class="mr my-1 text-uppercase"
                    :label="$t('color')"
                >
                    <CatalogFilterGroupOption
                        :link="selected.color_url"
                        :value="undefined"
                        label="Todas as Cores"
                        url-param="cor"
                        id-prefix="desktop"
                    />
                    <CatalogFilterGroupOption
                        v-for="color in filters.colors"
                        v-if="color.id && color.id !== 14"
                        :key="color.id"
                        :hex="color.rgb"
                        :label="color.name"
                        :link="color.url"
                        :value="color.url"
                        url-param="cor"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <!--                <div-->
                <!--                    class="hidden-md-down hidden-lg-up"-->
                <!--                    style="flex: 1 1 100%; height: 0"-->
                <!--                />-->

                <CatalogFilterGroupDesktop
                    v-if="displayFilterPrices"
                    :value="selected.price_url"
                    class="mr my-1 text-uppercase"
                    :label="$t('price')"
                >
                    <CatalogFilterGroupOption
                        :link="selected.price_url"
                        :value="undefined"
                        :label="$t('all_m')"
                        url-param="preco"
                        id-prefix="desktop"
                    />
                    <CatalogFilterGroupOption
                        v-for="price in filters.prices"
                        v-show="price.count > 0"
                        :key="price.id"
                        :count="price.count"
                        :label="getPriceLabel(price)"
                        :link="price.url"
                        :value="price.url"
                        url-param="preco"
                        id-prefix="desktop"
                    />
                </CatalogFilterGroupDesktop>

                <CatalogFilterGroupDesktop
                    v-if="displayFilterCategories"
                    :fallback-value-label="selected.category_name"
                    :label="$t(hasCollections ? 'category' : 'theme')"
                    :value="selected.category_url"
                    class="mr my-1 text-uppercase"
                >
                    <CatalogFilterGroupOption
                        :link="selected.category_url"
                        :value="undefined"
                        label="Todos os Temas"
                        url-param="categoria"
                        id-prefix="desktop"
                    />

                    <div v-if="hasCollections">
                        <hr class="my-2" />
                        <div class="text-secondary ml-4">
                            {{ $t('exclusiveCollections') }}
                        </div>
                        <CatalogFilterGroupOption
                            v-for="collection in filters.collections"
                            v-show="collection.count > 0"
                            :key="collection.id"
                            :count="collection.count"
                            :label="collection.name"
                            :link="collection.url"
                            :value="collection.url"
                            url-param="categoria"
                            id-prefix="desktop"
                        />
                    </div>

                    <div v-if="hasCategories">
                        <div v-if="hasCollections">
                            <hr class="my-2" />
                            <div class="text-secondary ml-4 text-uppercase">
                                {{ $t('themes') }}
                            </div>
                        </div>
                        <CatalogFilterGroupOption
                            v-for="category in filters.categories"
                            v-show="category.count > 0"
                            :key="category.id"
                            :count="category.count"
                            :label="category.name"
                            :link="category.url"
                            :value="category.url"
                            url-param="categoria"
                            id-prefix="desktop"
                        />
                    </div>
                </CatalogFilterGroupDesktop>

                <!--                <div class="hidden-lg-down" style="flex: 1 1 100%; height: 0" />-->
                <div class="hidden-xs-down">
                    <CatalogSortDesktop />
                </div>
                <!--Descomente para ativar filtro de multiplas cores -->
                <!--            <template v-if="displayMulticolorFilter">
                    <div
                        class="catalog-filter-check mr my-1 d-flex flex-align-center"
                        @click.stop.prevent="$emit('toggle-multiple-fabrics')"
                    >
                        <div>
                            <input
                                id="catalog-filter-multiple-colors-desktop"
                                :checked="multipleFabricsSelected"
                                class="cr-switch"
                                type="checkbox"
                            />
                            <label
                                class="text-uppercase text-bold catalog-delivery-ready-text"
                                for="catalog-filter-multiple-colors-desktop"
                                :class="[
                                    multipleFabricsSelected ? 'text-accent' : '',
                                ]"
                            >
                                {{ $t('_catalog._filter.withMultipleColors') }}
                            </label>
                        </div>
                    </div>

                    <div
                        v-if="displayInPhysicalStock || displaySelected"
                        class="bg-default-1 mr my-2 hidden-lg-down"
                        style="flex: 0 0 2px"
                    />
                </template>-->
                <!--Botao de limpar filtros-->
                <!--            <template v-if="displaySelected">
                    <a
                        :href="mainUrl"
                        class="catalog-filter-check my-1 text-underline d-flex flex-align-center"
                        @click="resetFilters"
                    >
                        <div>{{ $t('_catalog._filter.toClear') }}</div>
                    </a>
                </template>-->
            </div>
        </div>
        <template v-if="displayInPhysicalStock">
            <div
                :class="{ mr: displaySelected }"
                class="catalog-delivery-ready my-1 d-flex hidden-xs-down pt-3"
            >
                <div class="d-flex toggle-delivery-ready">
                    <div class="d-flex">
                        <div @click.stop.prevent="$emit('toggle-delivery-ready')">
                            <input
                                id="catalog-filter-delivery-ready-desktop"
                                :checked="deliveryReadySelected"
                                class="cr-switch"
                                type="checkbox"
                            />
                            <label
                                for="catalog-filter-delivery-ready-desktop"
                                class="text-uppercase text-bold catalog-delivery-ready-text"
                                :class="[deliveryReadySelected ? 'text-accent' : '']"
                            >
                                {{ $t('_catalog._filter.withDeliveryReady') }}
                            </label>
                        </div>
                        <span
                            v-tooltip:right="
                                !deliveryReadySelected
                                    ? `Nossos produtos são feitos por demanda, após o seu pedido. Ative o Envio Imediato e apresentaremos apenas os produtos em estoque, com o menor prazo de envio.`
                                    : `O Envio Imediato está ativo e você está visualizando apenas os produtos em estoque, com o menor prazo de envio.`
                            "
                            class="text-uppercase text-bold catalog-delivery-ready-text cursor-pointer ml-1"
                            >(?)</span
                        >
                    </div>
                </div>
            </div>

            <div
                v-if="displaySelected"
                class="bg-default-1 mr my-2 hidden-lg-down"
                style="flex: 0 0 2px"
            />
        </template>
    </div>
</template>

<script>
    import CatalogFilterGroupDesktop from './CatalogFilterGroupDesktop.vue';
    import CatalogFilterGroupOption from './CatalogFilterGroupOption.vue';
    import CatalogFilters from './CatalogFilters.vue';
    import CatalogClearFilters from './CatalogClearFilters.vue';
    import CatalogSortDesktop from './CatalogSortDesktop.vue';

    export default {
        name: 'CatalogFiltersDesktop',

        extends: CatalogFilters,

        components: {
            CatalogSortDesktop,
            CatalogFilterGroupOption,
            CatalogFilterGroupDesktop,
            CatalogClearFilters,
        },

        props: {
            isMobile: Boolean,
        },
    };
</script>
